import { filterManagerReports } from './map-manager-report';
import type {
  ManagerReportRow,
  ManagerReportsClusterOption,
  ManagerReportsFilter,
  ManagerReportsListData,
} from './types';

const MOCK_CLUSTERS: ManagerReportsClusterOption[] = [
  { id: '1', name: 'Образовательный' },
  { id: '2', name: 'Технологический' },
  { id: '3', name: 'Кластер Ломоносов' },
  { id: '4', name: 'Междисциплинарный' },
];

const MOCK_STATUSES = ['Принят', 'На рассмотрении', 'Требует доработки', 'Черновик'];

const MOCK_TEXT = `Наше дело не так однозначно, как может показаться: высокотехнологичная концепция общественного уклада требует анализа системы массового участия.`;

function createMockReport(index: number): ManagerReportRow {
  const year = 2026 - (index % 10);
  const status = MOCK_STATUSES[index % MOCK_STATUSES.length];

  return {
    id: 1000 - index,
    createdAt: `2026-05-03T${String(9 + (index % 8)).padStart(2, '0')}:21:00`,
    reportYear: String(year),
    residentId: 100 + (index % 5),
    residentName: 'ООО «Компания_имя»',
    status,
    isSign: index % 3 !== 1,
    companyName: 'ООО «Компания_название»',
    metrics: {
      revenue: { plan: '1 000 000', fact: '950 000' },
      invest_infra: { plan: '500 000', fact: '480 000' },
      invest_rnd: { plan: '300 000', fact: '310 000' },
      employees: { plan: '50', fact: '48' },
      export_share: { plan: '10', fact: '9' },
      rid: { plan: '5', fact: '4' },
    },
    revenue_dev: '-5',
    invest_infra_dev: '-4',
    invest_rnd_dev: '3',
    employees_dev: '-4',
    export_share_dev: '-10',
    rid_dev: '-20',
    comment: MOCK_TEXT,
    projectNames: MOCK_TEXT,
    projectReadiness: MOCK_TEXT,
    rids: MOCK_TEXT,
    commercialization: MOCK_TEXT,
    stateSupport: MOCK_TEXT,
    attachments: [
      {
        id: 1,
        name: 'Файл. Некоторое название файла PDF.',
        url: '#',
        size: '24.4 MB',
      },
    ],
    fioSignatory: 'Грушев Н. П.',
    nameOrganization: 'ООО «Компания_название»',
    certAuthority: 'Название удостоверяющего центра',
    dateSign: '2026-05-03T09:21:00',
    verifyResult: true,
    isSigned: index % 3 !== 1,
  };
}

const mockReports: ManagerReportRow[] = Array.from({ length: 50 }, (_, index) =>
  createMockReport(index),
);

export function getMockManagerReportsList(params: {
  q?: string;
  filter?: ManagerReportsFilter;
}): ManagerReportsListData {
  let items = [...mockReports];

  if (params.filter?.year) {
    items = items.filter((report) => report.reportYear === params.filter?.year);
  }

  items = filterManagerReports(items, params);

  return {
    items,
    clusters: MOCK_CLUSTERS,
  };
}

export function getMockManagerReportById(id: number): ManagerReportRow | null {
  return mockReports.find((report) => report.id === id) ?? null;
}
